import * as yup from "yup";
import I18n from "@/i18n-js/instance";

export const CREATE_CONVERSATION_SCHEMA = yup.object({
  text: yup
    .string()
    .required(I18n.t("support_widget.send_message_form.error.text")),
  type: yup
    .string()
    .required(I18n.t("support_widget.send_message_form.error.type")),
  priority: yup
    .string()
    .required(I18n.t("support_widget.send_message_form.error.priority")),
});

export const UPDATE_CONVERSATION_SCHEMA = yup.object({
  comment: yup.string().required("This field is required"),
});

export type CreateConversationSchema = yup.InferType<
  typeof CREATE_CONVERSATION_SCHEMA
>;
export type UpdateConversationSchema = yup.InferType<
  typeof UPDATE_CONVERSATION_SCHEMA
>;
